module.exports = __webpack_public_path__ + "02_bob_gold.1fc276dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/02_bob_gold.png
// module id = 2o/M
// module chunks = 0